module.exports = __webpack_public_path__ + "img/educacao-emprendedora-ba.3206c7e9.png";